<app-selector-app-env [lastRoute]="data.lastRoute" (close)="close($event)"></app-selector-app-env>
